import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function Tooling() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/produktionsudstyr-specialmaskine.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-cff9eab60c19441fbcd0a9e6e378026e-mv2.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Værktøj - JARCon ApS"
        description="Specialværktøj, fiksturer og tilpassede værktøjsløsninger til industri og produktion."
      />

      <PageHeader
        badge="Værktøjsløsninger"
        title="Værktøj"
        subtitle="Specialværktøj • Fiksturer • Montage- og kontrolværktøjer"
        breadcrumbs={[
          { label: 'Produktionsudstyr', path: '/produktionsudstyr' },
          { label: 'Værktøj' },
        ]}
        ctaText="Hør om specialværktøj"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Præcision &amp; Ergonomi
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Skræddersyede værktøjsløsninger og fiksturer
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Relevante værktøjsløsninger, specialværktøj og fiksturer udviklet til konkrete opgaver i montage- og bearbejdningsprocesser.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Et godt fikstur eller specialværktøj sparer tid ved hver eneste operation, sikrer ensartet emnekvalitet og forebygger fejl i samleprocessen.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-crosshairs" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">Montagefiksturer</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Præcise fiksturer med hurtigspænding, styretappe og pneumatisk fastspænding for hurtig og ensartet samling.
                </p>
              </div>

              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-compass-drafting" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">Kontrol- &amp; Måleværktøj</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Go/No-Go tolerancelære og kontrolfiksturer, der gør det nemt for operatører at verificere kritiske mål.
                </p>
              </div>
            </div>

            <GalleryGrid
              title="Værktøj og fiksturer galleri"
              subtitle="Klik for at se detaljerede billeder"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Værktøjsområder
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Specialværktøj til maskiner</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Montagefiksturer med hurtigskift</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Svejse- og limfiksturer</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Ergonomiske håndværktøjer</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Brug for specialværktøj?
              </span>
              <p className="text-xs text-slate-300">
                Kontakt JARCon for konstruktion og fremstilling af værktøjer til din produktion.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
